export const apiProductionUrl = process.env.REACT_APP_API_URL || "https://api.rethinkplatform.org/api/v1";
